var React = require('react');

function Earth (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.42 3l-.026.001c-7.037.32-12.551 6.224-12.39 13.264.16 7.04 5.938 12.678 12.981 12.678s12.821-5.639 12.982-12.678C29.127 9.225 23.613 3.32 16.576 3H15.42zm-.517 2.249v9.654H5.267a10.74 10.74 0 019.636-9.654zm2.164 0a10.74 10.74 0 019.636 9.654h-9.636V5.249zM5.271 17.067h9.632v9.605a10.724 10.724 0 01-9.632-9.605zm11.796 0H26.7a10.724 10.724 0 01-9.632 9.605v-9.605z"}));
}

Earth.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = Earth;

Earth.default = Earth;
